import { useFacilityProfile } from "@src/appV2/Facilities/api/useFacilityProfile";
import { type WindowingStrategyConfiguration } from "@src/appV2/Facilities/types";

export function useReliableWindowingSequence(workplaceId: string) {
  const { data: facilityProfile } = useFacilityProfile({
    workplaceId,
    projection: "windowingSequence",
  });

  const windowingSequenceConfig = facilityProfile?.windowingSequence?.sequence ?? [];
  const reliableAndFamiliarWindowingConfig = windowingSequenceConfig?.find((strategy) => {
    if (typeof strategy !== "string" && strategy?.name === "RELIABLE_AND_FAMILIAR") {
      return strategy;
    }

    return undefined;
  }) as WindowingStrategyConfiguration | undefined;

  const maybeMinVerifiedShiftsForFamiliarity = Number(
    reliableAndFamiliarWindowingConfig?.config?.minVerifiedShiftsForFamiliarity
  );
  const maybeDaysToEvaluateFamiliarity = Number(
    reliableAndFamiliarWindowingConfig?.config?.daysToEvaluateFamiliarity
  );

  const minVerifiedShiftsForFamiliarity = Number.isNaN(maybeMinVerifiedShiftsForFamiliarity)
    ? 1
    : maybeMinVerifiedShiftsForFamiliarity;

  const daysToEvaluateFamiliarity = Number.isNaN(maybeDaysToEvaluateFamiliarity)
    ? 30
    : maybeDaysToEvaluateFamiliarity;

  return {
    minVerifiedShiftsForFamiliarity,
    daysToEvaluateFamiliarity,
  };
}
